import React from 'react';
import MenuMobile from "./MenuMobile";
import Menu from "./Menu";

const NavBar = () => {
    return (
        <div>
            <MenuMobile/>
            <Menu/>
        </div>
    );
};

export default NavBar;